import {
  LOAD_BILLING_INFO,
  LOAD_BILLING_INFO_FAIL, LOAD_BILLING_INFO_SUCCESS,
  LOAD_WORKSPACE_ALL_CLIENTS, LOAD_WORKSPACE_ALL_CLIENTS_FAIL, LOAD_WORKSPACE_ALL_CLIENTS_SUCCESS,
  LOAD_WORKSPACE_CLIENTS,
  LoadBillingInfoSuccess,
  LoadWorkspaceAllClientsSuccess,
  LOAD_WORKSPACE_INVITATIONS, LOAD_WORKSPACES,
  LoadWorkspaceClients,
  LoadWorkspaceInvitations, LoadWorkspaces,
  SET_WORKSPACE_ID_ENTITIES,
  SetWorkspaceIdEntities,
  WorkspaceAction, UPDATE_WORKSPACE, UpdateWorkspace, RESET_WORKSPACE_STATE
} from "../actions/workspace.action";
import {WorkspaceClient} from "../../user-managment/workspace-client";
import {WorkspaceInvitation} from "../../user-managment/workspace-invitation";
import {Workspace} from "../../user-managment/workspace";
import {GlobalEvent} from "../../shared/services/global-event-dispatcher/global-event";
import {GlobalEventDispatcherService} from "../../shared/services/global-event-dispatcher/global-event-dispatcher.service";

export interface IWorkspaceState {
  workspaces: Workspace[];
  workspaceClients: WorkspaceClient[];
  workspaceInvitations: WorkspaceInvitation[];
  workspaceIdEntities: IWorkspaceIdEntities;
  billingInfo: IBillingInfoEntities;
  loading: boolean;
  loaded: boolean;
}

export interface IBillingInfoEntities {
  billingInfo: any;
  loading: boolean;
  loaded: boolean;
}

export interface IWorkspaceIdEntities {
  ownerWorkspaceId: number;
  currentWorkspaceId: number;
  currentWorkspaceRoleId: number;
  globalEventDispatcherService: GlobalEventDispatcherService;
}

export const initialState: IWorkspaceState = {
  workspaces: [],
  workspaceClients: [],
  workspaceInvitations: [],
  workspaceIdEntities: {
    ownerWorkspaceId: localStorage.getItem('dbOwnWorkspaceId') && +localStorage.getItem('dbOwnWorkspaceId'),
    currentWorkspaceId: localStorage.getItem('dbCurrentWorkspaceId') && +localStorage.getItem('dbCurrentWorkspaceId'),
    currentWorkspaceRoleId: localStorage.getItem('dbCurrentWorkspaceRoleId') && +localStorage.getItem('dbCurrentWorkspaceRoleId'),
    globalEventDispatcherService: null
  },
  billingInfo: {
    billingInfo: null,
    loading: false,
    loaded: false
  },
  loading: false,
  loaded: true
};

export function reducer(state: IWorkspaceState = initialState, action: WorkspaceAction): IWorkspaceState {

  let payload;

  switch (action.type) {
    case SET_WORKSPACE_ID_ENTITIES:
      payload = (<SetWorkspaceIdEntities>action).payload;
      payload && payload.ownerWorkspaceId && localStorage.setItem('dbOwnWorkspaceId', payload.ownerWorkspaceId.toString());
      payload && payload.currentWorkspaceId && localStorage.setItem('dbCurrentWorkspaceId', payload.currentWorkspaceId.toString());
      payload && payload.currentWorkspaceRoleId && localStorage.setItem('dbCurrentWorkspaceRoleId', payload.currentWorkspaceRoleId.toString());
      payload && payload.globalEventDispatcherService && payload.globalEventDispatcherService.dispatchEvent(GlobalEvent.workspaceSwitch);
      return {
        ...state,
        workspaceIdEntities: {
          ownerWorkspaceId: payload && payload.ownerWorkspaceId,
          currentWorkspaceId: payload && payload.currentWorkspaceId,
          currentWorkspaceRoleId: payload && payload.currentWorkspaceRoleId,
          globalEventDispatcherService: payload && payload.globalEventDispatcherService
        }
      };
    case LOAD_WORKSPACE_CLIENTS:
      payload = (<LoadWorkspaceClients>action).payload;
      return {
        ...state,
        workspaceClients: payload,
        loading: false,
        loaded: true
      };
    case LOAD_WORKSPACE_INVITATIONS:
      payload = (<LoadWorkspaceInvitations>action).payload;
      return {
        ...state,
        workspaceInvitations: payload,
        loading: false,
        loaded: true
      };
    case LOAD_WORKSPACE_ALL_CLIENTS:
      return {
        ...state,
        loading: true,
        loaded: false
      };
    case LOAD_WORKSPACE_ALL_CLIENTS_SUCCESS:
      payload = (<LoadWorkspaceAllClientsSuccess>action).payload;
      return {
        ...state,
        workspaceClients: payload.clients,
        workspaceInvitations: payload.invitations,
        loading: false,
        loaded: true
      };
    case LOAD_WORKSPACE_ALL_CLIENTS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true
      };

    case LOAD_BILLING_INFO:
      return {
        ...state,
        billingInfo: {
          ...state.billingInfo,
          loading: true,
          loaded: false
        }
      };

    case LOAD_BILLING_INFO_SUCCESS:
      payload = (<LoadBillingInfoSuccess>action).payload;

      return {
        ...state,
        billingInfo: {
          ...state.billingInfo,
          billingInfo: payload,
          loading: false,
          loaded: true
        }
      };

    case LOAD_BILLING_INFO_FAIL:
      return {
        ...state,
        billingInfo: {
          ...state.billingInfo,
          billingInfo: null,
          loading: false,
          loaded: true
        }
      };
    case LOAD_WORKSPACES:
      payload = (<LoadWorkspaces>action).payload;
      return  {
        ...state,
        workspaces: payload
      };
    case UPDATE_WORKSPACE:
      payload = (<UpdateWorkspace>action).payload;
      const index = state.workspaces.findIndex(workspace => workspace.workspaceId === payload.workspaceId);
      if (index < 0) return null;
      return {
        ...state,
        workspaces: state.workspaces.map((item, i) =>
          i === index ? payload : item
        )
      };
    case RESET_WORKSPACE_STATE:
      return {
        workspaces: [],
        workspaceClients: [],
        workspaceInvitations: [],
        workspaceIdEntities: {
          ownerWorkspaceId: null,
          currentWorkspaceId: null,
          currentWorkspaceRoleId: null,
          globalEventDispatcherService: null
        },
        billingInfo: {
          billingInfo: null,
          loading: false,
          loaded: false
        },
        loading: false,
        loaded: true
      };
  }

  return state;
}
